import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../Context/User/";
import { ACESSOS } from "../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../Validations/UsuarioTela";
import SubNavDropDown from "../SubNavDropDown/SubNavDropDown";
import { SubNavGestaoAssistenciaTecAtendimentos } from "./subnavs/GestaoAssTecAtendimento";
import { SubNavAssTecRelatorios } from "./subnavs/GestaoAssTecRelatorios";
import { SubNavGestaoAssistenciaTecCadastros } from "./subnavs/GestaoAssTecCadastros";

export default function AssistenciaTecnicaTab() {
    const { UserInfor } = useUserInfor();

    return (
        <div className="tab-pane py-5 p-lg-0 active" id="AssistenciaTecnicaTab">
            <div
                id="kt_header_menu2"
                className="header-menu header-menu-mobile header-menu-layout-default header-menu-root-arrow"
            >
                <ul className="menu-nav">
                    {mostrarNavDeTela(
                        ACESSOS.ASSISTENCIA.TELAS.GESTAO_CLIENTES.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_CLIENTES
                                        .DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Gestão de Clientes
                                </span>
                            </NavLink>
                        </li>
                    )}
                    <SubNavDropDown
                        title={"Atendimentos"}
                        telas={[
                            ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                                .MEUS_ATENDIMENTOS.USUARIO.ID_TELA,
                        ]}
                    >
                        <SubNavGestaoAssistenciaTecAtendimentos />
                    </SubNavDropDown>

                    <SubNavDropDown
                        title={"Gestão de Cadastros"}
                        telas={[
                            ACESSOS.ASSISTENCIA.MODAIS
                                .DISPONIBILIDADE_AGENDAMENTO.ID_TELA,
                        ]}
                    >
                        <SubNavGestaoAssistenciaTecCadastros />
                    </SubNavDropDown>
                    <SubNavDropDown
                        title={"Relatórios"}
                        telas={[
                            ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                                .CAPYS_BI.ID_TELA,
                        ]}
                    >
                        <SubNavAssTecRelatorios />
                    </SubNavDropDown>

                    {mostrarNavDeTela(
                        ACESSOS.ASSISTENCIA.TELAS.TRIAGEM.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.ASSISTENCIA.TELAS.TRIAGEM.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">Triagem</span>
                            </NavLink>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}
